module.exports = __webpack_public_path__ + "img/base_nature_jardin.e2820385.svg";